/**
 * Shipping Option
 *
 * @export
 * @class ShippingOptions
 */
export class ShippingOption {
    id: string;
    tipoEntrega: string;
    descripcion: string;
    orden: string;
    seleccionado: boolean;
    descuento: number;
    fechaEntrega: string;
}
